export enum StartingLocation {
    SouthCape = 0,
    Safe = 1,
    Unsafe = 2,
    ForcedUnsafe = 3,
}
